function _(n,o,r){o.exports=function(){var n,o,r=Array.from;return"function"==typeof r&&(o=r(n=["raz","dwa"]),Boolean(o&&o!==n&&"dwa"===o[1]))}}
//# sourceMappingURL=is-implemented.min.js.map